import React, { Children } from 'react';
import { Link } from 'react-router-dom';
export const GallerySection = () => {
  const images = [{
    src: 'https://legandgo.com/wp-content/uploads/2024/09/Soft-Play-Foam-Climbing-Blocks-for-sensory-play.jpg',
    alt: 'Colorful soft play setup with blocks'
  }, {
    src: 'https://img.freepik.com/premium-photo/laughing-child-boy-having-fun-ball-pit-birthday-party-kids-amusement-park-indoor-play-center-laughing-playing-with-colorful-balls-playground-ball-pool_1032209-227.jpg',
    alt: 'Children playing in ball pit'
  }, {
    src: 'https://www.shutterstock.com/image-photo/game-room-kindergarten-african-american-600nw-2407935703.jpg',
    alt: 'Toddler on a soft play slide'
  }, {
    src: 'https://i.ebayimg.com/images/g/230AAeSw~QFof2Ny/s-l1200.jpg',
    alt: 'Birthday party setup with soft play equipment'
  }, {
    src: 'https://happy-times.eu/wp-content/uploads/2016/03/homepage-happykids-cover.jpeg',
    alt: 'Kids playing in bounce house'
  }, {
    src: 'https://www.badut.id/wp-content/uploads/2016/01/photo-booth.jpg',
    alt: 'Family photo booth setup'
  }];
  return <section id="gallery" className="bg-white py-12 md:py-20" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center" data-id="element-147">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-148">Play in Action</h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-500" data-id="element-149">
            See how our soft play equipment creates magical moments for little
            ones
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-150">
          {images.map((image, index) => <div key={index} className="overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-151">
              <img src={image.src} alt={image.alt} className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300" data-id="element-152" />
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-153">
          <Link to="/contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-secondary-500 hover:bg-secondary-600 transition" onClick={() => window.scrollTo(0, 0)} data-id="element-154">
            Book Your Play Date
          </Link>
        </div>
      </div>
    </section>;
};